import { Button } from './Button'

export type PaginationProps = {
  /** 1 起始页码 */
  page: number
  pageSize: number
  /** 总条数；未知总数时不传，仅按当前页判断是否有下一页 */
  total?: number
  onChange: (page: number) => void
  className?: string
}

export function Pagination({ page, pageSize, total, onChange, className = '' }: PaginationProps) {
  const totalPages = total === undefined ? undefined : Math.max(1, Math.ceil(total / pageSize))
  const hasPrev = page > 1
  const hasNext = totalPages === undefined ? true : page < totalPages

  return (
    <div className={`flex items-center justify-between gap-2 ${className}`.trim()}>
      <span className="text-xs text-[var(--color-muted)]">
        {total !== undefined ? `共 ${total} 条 · 第 ${page}/${totalPages} 页` : `第 ${page} 页`}
      </span>
      <div className="flex items-center gap-2">
        <Button type="button" variant="secondary" size="sm" disabled={!hasPrev} onClick={() => onChange(page - 1)}>
          上一页
        </Button>
        <Button type="button" variant="secondary" size="sm" disabled={!hasNext} onClick={() => onChange(page + 1)}>
          下一页
        </Button>
      </div>
    </div>
  )
}
